const LibrarySidebar = ({ renderType, setMenutype, menuType, renderExpress }) => {
  const handleClick = (key) => {
    setMenutype(key);
  };
  return (
    <ul className="sidebarul">
      {renderType === 'author_none' ? (
        <li className={menuType === 'CUSTOM' ? 'active' : ''} onClick={() => handleClick('CUSTOM')}>
          Custom
        </li>
      ) : (
        ''
      )}
      <li className={menuType === 'REGULAR' ? 'active' : ''} onClick={() => handleClick('REGULAR')}>
        Regular
      </li>
      {renderExpress && (
        <li className={menuType === 'EXPRESS' ? 'active' : ''} onClick={() => handleClick('EXPRESS')}>
          Express
        </li>
      )}
    </ul>
  );
};

export default LibrarySidebar;
